import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { DateRange } from "react-date-range";
import React, { useState, useEffect } from "react";

const DateRangePicker = (props) => {
  const [state, setState] = useState([props.initialDate]);

  //  to update state when props.initialDate changes
  useEffect(() => {
    setState([props.initialDate]);
  }, [props.initialDate]);

  return (
    <DateRange
      // onChange function to handle date range selection changes
      onChange={(item) => {
        // Update state with the selected date range
        setState([item.selection]);
        // Call the rangeSelected function passed as props with the selected date range
        props.rangeSelected([item.selection]);
      }}
      showSelectionPreview={false}
      showMonthAndYearPickers={false}
      showDateDisplay={false}
      moveRangeOnFirstSelection={false}
      months={1}
      ranges={state}
      direction="horizontal"
    />
  );
};

export default DateRangePicker;
